import React, { useCallback, useEffect, useState } from 'react';
import { MenuProps } from 'antd';
import { AppRoutes } from '../../constants/route';
import MenuSubItem from './MenuSubItem';
import { Thread } from '../../interfaces/copilotChat';

type ThreadItemProps = {
  thread: Thread;
  actions?: MenuProps['items'];
  getActions?: (thread: Thread) => MenuProps['items'];
  isCurrentThread: boolean;
  isProcessing: boolean;
  isEditingTitle: boolean;
  onTitleChange: (thread: Thread, title: string) => void;
  onAbortTitleChange: () => void;
};

const ThreadItem: React.FC<ThreadItemProps> = ({
  thread,
  actions,
  getActions,
  isCurrentThread,
  isProcessing,
  isEditingTitle,
  onTitleChange,
  onAbortTitleChange,
}) => {
  const threadPath = `${AppRoutes.adminAgent.path}/thread/${thread.id}`;
  const threadTitle = thread.title || 'Untitled';
  const [allActions, setAllActions] = useState<MenuProps['items']>([]);
  useEffect(() => {
    let _actions: MenuProps['items'] = [];
    if (actions) {
      _actions = actions;
    } else if (getActions) {
      _actions = getActions(thread);
    }
    setAllActions(_actions);
  }, [actions, getActions]);

  const isCreating = isCurrentThread && isProcessing && !thread.title;
  const handleOnTitleChange = useCallback(
    (newTitle: string) => onTitleChange(thread, newTitle),
    [onTitleChange, thread]
  );

  return (
    <MenuSubItem
      label={threadTitle}
      path={threadPath}
      actions={allActions}
      tooltip={threadTitle}
      isLoading={isCreating}
      isReadOnly={false}
      isEditingTitle={isEditingTitle}
      onTitleChange={handleOnTitleChange}
      onAbortTitleChange={onAbortTitleChange}
    />
  );
};

export default ThreadItem;
